import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { login as loginApi, getMe } from "../api/auth";
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        const stored = localStorage.getItem("user");
        return stored ? JSON.parse(stored) : null;
    });
    const [token, setToken] = useState(() => localStorage.getItem("token"));
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (token) {
            getMe()
                .then((u) => {
                const userData = { id: u.id, email: u.email, name: u.name, role: u.role };
                setUser(userData);
                localStorage.setItem("user", JSON.stringify(userData));
            })
                .catch(() => {
                setToken(null);
                setUser(null);
                localStorage.removeItem("token");
                localStorage.removeItem("user");
            })
                .finally(() => setLoading(false));
        }
        else {
            setLoading(false);
        }
    }, [token]);
    const login = useCallback(async (email, password) => {
        const res = await loginApi({ email, password });
        localStorage.setItem("token", res.token);
        localStorage.setItem("user", JSON.stringify(res.user));
        setToken(res.token);
        setUser(res.user);
    }, []);
    const logout = useCallback(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setToken(null);
        setUser(null);
    }, []);
    return (_jsx(AuthContext.Provider, { value: { user, token, loading, login, logout }, children: children }));
}
export function useAuth() {
    return useContext(AuthContext);
}
